import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthComponent } from './auth.component';

const routes: Routes = [
  // {
  //   path: 'login',
  //   // component: AuthComponent
  // },
  // {
  //   path: 'register',
  //   // component: AuthComponent
  // },
  // {
  //   path: 'forgot',
  //   // component: AuthComponent
  // },
  // {
  //   path: 'reset-password',
  //   // component: AuthComponent
  // },
  // { path: '**', redirectTo: 'login', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
